(function ($, App, Utils, Components) {
  'use strict';

  const logger = new Logger('DataShoppingList');

  Components.create('DataShoppingList', {

    Selectors: {
      list: '.js-shopping-list',
      container: '.js-shopping-list-container',
      add: '.js-shopping-list-add-row',
      remove: '.js-shopping-list-remove-row',
      input: '.js-shopping-list-input',
      item: '.js-shopping-list-item',
      placeHolder: '.js-shopping-list-placeholder'
    },

    getPlaceHolder: () => {
      return `
      <div class="grid-x grid-margin-x js-shopping-list-placeholder">
        <div class="box gray cell large-8 large-offset-2">
          <i class="icon icon-list icon-big icon-gray"><!-- --></i>
          <p>${$(Components.DataShoppingList.Selectors.list).data('shoppinglistPlaceholder')}</p>
        </div>
      </div>
      `;
    },

    bindEvents: () => {

      $(Components.DataShoppingList.Selectors.input).on('keydown.sl', function (e) {
        e.stopPropagation();
        if (e.which === 13 || e.keyCode === 13) {
          Components.DataShoppingList.addRow();
        }
      });

      $(Components.DataShoppingList.Selectors.list).on('click.sl', Components.DataShoppingList.Selectors.remove, function (e) {
        e.stopPropagation();
        let row = $(this).parent();
        Components.DataShoppingList.removeRow(row);
      });

    },

    removeRow: (row) => {
      let rowValue = row.data('value');
      Components.DataShoppingList.popData(rowValue);
      $(`li[data-value="${rowValue}"]`).remove();

      Components.trigger('shoppingitem:removed', [{
        shoppingList: $(Components.DataShoppingList.Selectors.list).attr('data-shoppinglist'),
        itemRemoved: rowValue
      }]);
    },

    addRow: () => {
      let $input = $(Components.DataShoppingList.Selectors.input);
      let val = $input.val();
      if (val && Components.DataShoppingList.setData(val)) {
        $(Components.DataShoppingList.Selectors.container).append(`<li class="js-shopping-list-item cell" data-value="${val}" >${val} <button class="js-shopping-list-remove-row icon-bin"></button></li>`);
        $input.val('');

        Components.trigger('shoppingitem:added', [{
          shoppingList: $(Components.DataShoppingList.Selectors.list).attr('data-shoppinglist'),
          newItem: val
        }]);
      }
    },

    saveList: list => {
      return axios({
        method: 'post',
        url: $(Components.DataShoppingList.Selectors.list).data('shoppinglistEndpoint'),
        responseType: 'json',
        data: {noteText: list ? list.replace(/,/g, '\n') : null}
      })
    },

    popData: val => {

      let dataList = $(Components.DataShoppingList.Selectors.list).attr('data-shoppinglist');
      let list = dataList.split(',');
      list.splice(list.indexOf(val), 1);

      $(Components.DataShoppingList.Selectors.list).attr('data-shoppinglist', list.toString());

      Components.DataShoppingList.saveList(list.toString()).then(res => {
        logger.d(res);
        if (!list.length) {
          $(Components.DataShoppingList.Selectors.list).append(Components.DataShoppingList.getPlaceHolder());
        }
      });

      return list;

    },


    setData: val => {
      let list = [];
      let dataList = $(Components.DataShoppingList.Selectors.list).attr('data-shoppinglist');

      if (dataList) {
        list = dataList.split(',');
      }

      if (list.indexOf(val) < 0) {
        list.push(val);
        $(Components.DataShoppingList.Selectors.list).attr('data-shoppinglist', list.toString());


        Components.DataShoppingList.saveList(list.toString()).then(res => {
          logger.d(res);
          if (list.length > 0 && $(Components.DataShoppingList.Selectors.placeHolder)) {
            $(Components.DataShoppingList.Selectors.placeHolder).remove();
          }
        });

        return list;
      }

      return false;
    },

    init: function () {
      Components.DataShoppingList.bindEvents();
    }
  });
})(jQuery, window.App, window.App.Utils, window.App.Components);
